/**
 * Builds a MapLibre style spec for the theme-matched vector basemap, served
 * from the QuickBox tile host. The glyphs and sprites are already live; the
 * `planet.json` TileJSON + `/planet/{z}/{x}/{y}.mvt` tiles come online once the
 * planet extract finishes. Until then the vector layer falls back to raster
 * (see `BasemapLayer.tsx`).
 */

import { layers } from "@protomaps/basemaps";
import type { StyleSpecification } from "maplibre-gl";
import type { ThemeName } from "../../components/theme/ThemeProvider";
import { FLAVORS } from "./flavors";

export const TILES_BASE = "https://tiles.quickbox.io";

export const buildBasemapStyle = (theme: ThemeName): StyleSpecification => ({
  version: 8,
  glyphs: `${TILES_BASE}/assets/fonts/{fontstack}/{range}.pbf`,
  sprite: `${TILES_BASE}/assets/sprites/v4/${theme === "defaulted" ? "light" : "dark"}`,
  sources: {
    protomaps: {
      type: "vector",
      url: `${TILES_BASE}/planet.json`,
      attribution: "© OpenStreetMap contributors · Protomaps",
    },
  },
  layers: layers("protomaps", FLAVORS[theme], { lang: "en" }),
});
